import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { UpgradeNowPopupComponent } from './components/upgrade-now-popup/upgrade-now-popup.component';
import {PaywallIconWarningComponent} from '@modules/paywall/components/paywall-icon-warning/paywall-icon-warning.component';
import {PaywallIconLastWarningComponent} from '@modules/paywall/components/paywall-last-icon-objects-warning/paywall-icon-last-warning.component';
import {PaywallWarnTemplateModalComponent} from '@modules/paywall/components/paywall-warn-template-modal/paywall-warn-template-modal.component';

@NgModule({
  declarations: [UpgradeNowPopupComponent,PaywallIconWarningComponent, PaywallIconLastWarningComponent, PaywallWarnTemplateModalComponent],
  imports: [CommonModule],
  exports: [UpgradeNowPopupComponent, PaywallIconWarningComponent, PaywallIconLastWarningComponent, PaywallWarnTemplateModalComponent]
})
export class PaywallModule {
  constructor() { }
  static forRoot():ModuleWithProviders{
    return {
      ngModule: PaywallModule,
      providers: []
    }
  }
}
